import { apiClient } from "lib/apiClient";
import { ResearchStaffLevelEnum } from "features/Research/types";

export interface IUser {
  active: boolean;
  authServiceId: string;
  creationDate: string;
  email: string;
  firstName: string;
  id: string;
  lastModifiedDate: string;
  lastLoginDate: string | null;
  lastName: string;
  companyId?: string;
  phone: string;
  phonePrefix: string;
  researchStaffEligible?: boolean;
  researchStaffLevel?: ResearchStaffLevelEnum | null;
  roles: string[];
}

export type IUsers = {
  active: number;
  disabled: number;
  total: number;
  objects: IUser[];
};

export const getCompanyGroupUsers = async (
  id: string | undefined,
  status: string,
  researchStaffOnly?: boolean
): Promise<IUsers> => {
  const response = await apiClient.get("/users", {
    params: { companyId: id || undefined, status, researchStaffOnly },
  });

  return response.data;
};
